import {AuthSegmentContext} from "../segmentContext/AuthSegmentContext";
import {useState} from "react";
import {auth, FirebaseUserType, firestore} from "../../database/firebase";

import {createUserWithEmailAndPassword, signInWithEmailAndPassword} from 'firebase/auth';
import {UserDTO} from "../../dtos/user/UserDTO";
import {addDoc, collection, doc, DocumentData, setDoc} from "firebase/firestore";
import {USERS_COLLECTION} from "../../constants/Constants";


export const AuthProvider = (props : any) =>
{
    const [fbUser, setFbUser] = useState<FirebaseUserType | null>(null);
    const [user, setUser] = useState<UserDTO | null>(null);


    const login = (email: string, password: string) =>
    {
        return signInWithEmailAndPassword(auth, email, password);
    }

    const register = (email: string, password: string) =>
    {
        return createUserWithEmailAndPassword(auth, email, password);
    }

    const saveNewUser = (user: UserDTO) =>
    {
        const userId = user.id;
        if (userId)
        {
            const ref = doc(firestore, USERS_COLLECTION, userId);
            setUser(user);
            return setDoc(ref, user);
        }

        throw new Error("Invalid UserId Provided");
    }

    const deleteUser = async () =>
    {
        if(auth.currentUser)
        {
            await auth.currentUser.delete();
        }
    }

    const provider =
    {
        fbUser,
        setFbUser,
        user,
        setUser,
        login,
        register,
        saveNewUser,
        deleteUser,
    };

    return (
        <AuthSegmentContext.Provider value={provider}>
            {props.children}
        </AuthSegmentContext.Provider>
    )
}